/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

export const facetNavigationAccordionSX: SxProps = {
	boxShadow: 0,
	backgroundColor: 'transparent',
	p: 0,
	m: 0,
	borderBottom: '1px solid #D9D9D9',
};
